import { Action } from '@otto-ec/tracking-bct';

type WishlistData = {
    variationId: string;
    basketItemId: string;
    trackingBasketId: string;
};

export class AddToWishlist {
    init() {
        document.querySelectorAll<HTMLDivElement>('.or_js_add2Wishlist').forEach(container => {
            if (container.dataset.initialized !== 'true') {
                const button = container.querySelector('.or_js_add2WishlistButton');

                container.classList.add('or_add2Wishlist--visible');
                container.setAttribute('data-initialized', 'true');

                const wishlistData: WishlistData = {
                    variationId: container.dataset.variationId!,
                    basketItemId: container.dataset.basketItemId!,
                    trackingBasketId: container.dataset.trackingBasketId!
                };

                button?.addEventListener('click', () => this.onButtonClick(wishlistData));
            }
        });
    }

    private async onButtonClick(wishlistData: WishlistData) {
        /*                                                               */
        await window.otto.wishlist.addItem(wishlistData.variationId, true, 'Basket');

        window.o_order.basket.service?.deleteItem(
            wishlistData.basketItemId,
            (newBasketContentHtml: string, redirectUrl: string) => {
                this.deleteFromBasketSuccess(wishlistData, newBasketContentHtml, redirectUrl);
            },
            (error: unknown) => {
                console.error('Error deleting item from basket:', error);
            }
        );
    }

    private deleteFromBasketSuccess(wishlistData: WishlistData, newBasketContentHtml: string, redirectUrl: string) {
        if (redirectUrl) {
            this.trackMoveEvent(wishlistData);
            window.o_order.basket.view?.redirectTo(redirectUrl);
        } else {
            window.o_order.basket.view?.updateBasket(newBasketContentHtml);
            this.trackMoveEvent(wishlistData);
        }
    }

    private trackMoveEvent(wishlistData: WishlistData) {
        const id = 'order_variation_mv_to_wl';
        const action: Action = {
            name: 'move',
            features: [
                {
                    id,
                    name: 'MovedToWishlist',
                    status: 'moved',
                    labels: {
                        order_BasketId: [wishlistData.trackingBasketId]
                    }
                },
                {
                    id: `${id}_1`,
                    variationId: wishlistData.variationId,
                    name: 'Variation',
                    parentId: id,
                    status: 'moved',
                    labels: {
                        order_BasketItemId: [wishlistData.basketItemId]
                    }
                }
            ]
        };
        window.o_order.tracking.submitEventMerge(action);
    }
}
